import { all } from 'redux-saga/effects';
import appSagas from '../app/saga';
import authSaga from '../auth/saga';
import adminSaga from '../admin/saga';

export function* rootSaga() {
  yield all([appSagas(), authSaga(), adminSaga()]);
}
